var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedots2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.257 4.51172C16.6085 4.51172 15.2598 5.86049 15.2598 7.509C15.2598 9.1575 16.6085 10.5063 18.257 10.5063C19.9055 10.5063 21.2543 9.1575 21.2543 7.509C21.2543 5.86049 19.9055 4.51172 18.257 4.51172ZM18.257 25.4927C16.6085 25.4927 15.2598 26.8414 15.2598 28.4899C15.2598 30.1385 16.6085 31.4872 18.257 31.4872C19.9055 31.4872 21.2543 30.1385 21.2543 28.4899C21.2543 26.8414 19.9055 25.4927 18.257 25.4927ZM18.257 15.0022C16.6085 15.0022 15.2598 16.351 15.2598 17.9995C15.2598 19.648 16.6085 20.9968 18.257 20.9968C19.9055 20.9968 21.2543 19.648 21.2543 17.9995C21.2543 16.351 19.9055 15.0022 18.257 15.0022Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots2);
export default __webpack_public_path__ + "static/media/threedots2.aa203b8fecf8ee5d6368555d9a3f3740.svg";
export { ForwardRef as ReactComponent };